import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

import { Mode, DeviceType } from '../../models/enums'

import VoiceInput from './OldVoiceInput'
import SendTextBox from './SendTextBox'

const UserRequest = (): JSX.Element => {
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const currentDeviceType = useSelector((state: RootState) => state.viewReducer.currentDeviceType)
  const mediumLandscape = useSelector((state: RootState) => state.viewReducer.mediumLandscape)

  const [gridRowStart, setGridRowStart] = useState<number>()
  const [gridRowSpan, setGridRowSpan] = useState<number>()

  useEffect(() => {
    switch (currentDeviceType) {
      case DeviceType.landscape:
      case DeviceType.widgetLandscape: {
        if (typeof configuration?.answerpanel === 'object') {
          switch (mode) {
            case Mode.text:
              if (configuration.answerpanel.landscape?.containerRowEndText) {
                setGridRowStart(configuration.answerpanel.landscape.containerRowEndText)
                setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText)
              } else {
                setGridRowStart(11)
                setGridRowSpan(2)
              }
              break
            case Mode.vocal: {
              setGridRowStart(1)
              if (configuration.answerpanel.landscape?.containerRowStart) {
                setGridRowSpan(configuration.answerpanel.landscape.containerRowStart - 1)
              } else {
                setGridRowSpan(3)
              }
              break
            }
            default:
              break
          }
        } else {
          setGridRowStart(mode === Mode.text ? 11 : 1)
          setGridRowSpan(mode === Mode.text ? 2 : 3)
        }
        break
      }
      case DeviceType.borne:
      case DeviceType.widgetBorne: {
        if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
          setGridRowStart(1)
          setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1)
        } else {
          setGridRowStart(4)
          setGridRowSpan(2)
        }
        break
      }
    }
  }, [mode, configuration.answerpanel, currentDeviceType])

  return (
    <div
      id='retorik-userRequest'
      className={`rf-relative rf-z-util rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-py-4 large-vertical:rf-py-5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start
        ${mode === Mode.text && 'landscape-retorik:rf-justify-start'}
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`}
      style={{
        gridRow: `${gridRowStart} / span ${gridRowSpan}`
      }}
    >
      {mode === Mode.text ? <SendTextBox /> : <VoiceInput />}
    </div>
  )
}

export default UserRequest
